import { render, staticRenderFns } from "./GamesPage.vue?vue&type=template&id=a21df9b8&"
import script from "./GamesPage.vue?vue&type=script&lang=js&"
export * from "./GamesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports